import b from 'b_';
import { Link, MarkdownExtXContent, Text } from 'platform-components';
import React, { useCallback } from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './sidebar-themes__root-theme-view.scss';

interface OwnProps {
    id: number | string;
    name: string;
    onClick: (id: number | string) => void;
    selected?: boolean;
    to: string;
}

interface Props extends OwnProps {}

export const RootThemeView = ({ id, name, onClick, selected, to }: Props) => {
    const handleParentThemeClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    return (
        <div className="sidebar-themes__root-theme" {...accessibleClick(() => handleParentThemeClick())}>
            <Link
                isRouter
                mix={b('sidebar-themes', 'root-theme-link', { selected })}
                theme={Link.THEME.STEALTHY}
                to={to}
            >
                <Text size={Text.SIZE.XL} weight={selected ? Text.WEIGHT.M : Text.WEIGHT.S}>
                    <MarkdownExtXContent>{name}</MarkdownExtXContent>
                </Text>
            </Link>
        </div>
    );
};

export default React.memo(RootThemeView);
